module.exports = __webpack_public_path__ + "static/img/icon-2.9fe1883.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-1/icon-2.png
// module id = q3yw
// module chunks = 0